import React from "react";
import "../Styles/Contact.css";
import {
  FaLinkedinIn,
  FaGithub,
  FaMailBulk,
  FaMobileAlt,
  FaHome,
  FaWhatsapp,
} from "react-icons/fa";

import emailjs from "@emailjs/browser";
import { Form, TextArea } from "semantic-ui-react";
import Swal from "sweetalert2";

export const Contact = () => {
  const handleOnSubmit = (e) => {
    e.preventDefault();
    console.log(e);
    emailjs
      .sendForm(
        "service_25zgp04",
        "template_f577nu9",
        e.target,
        "2yuwxVLW4SPwKBiWL"
      )
      .then(
        (result) => {
          console.log(result.text);
          Swal.fire({
            icon: "success",
            title: "Message Sent Successfully",
          });
        },
        (error) => {
          console.log(error.text);
          Swal.fire({
            icon: "error",
            title: "Ooops, something went wrong",
            text: error.text,
          });
        }
      );
    e.target.reset();
  };

  return (
    <div className="ContactContainer" id="contactSection">
      <div>
        <h1>Contact Me</h1>

        <div>
          <Form onSubmit={handleOnSubmit}>
            <input
              label="Email"
              className="feedback_input"
              name="to_name"
              placeholder="Email…"
              required
            />
            <input
              className="feedback_input"
              label="Name"
              name="from_name"
              placeholder="Name…"
              required
            />
            <input
              className="feedback_input"
              control={TextArea}
              label="Message"
              name="message"
              placeholder="Message…"
              required
            />
            <button type="submit" color="green">
              Send
            </button>
          </Form>
        </div>

        <hr style={{ width: "95vw" }} />
        <p className="text">Liked my work? Want to get in touch?</p>
        <p className="text">You can reach out to me at:</p>
        <div>
          <h3>
            <FaMobileAlt className="contactlogotop" />
            &nbsp;Contact No.&nbsp; › &nbsp;<span>9370176208</span>
          </h3>
          <h3>
            <a href="mailto:nikeshborkar008@gmail.com">
              <FaMailBulk className="contactlogotop" />
              &nbsp;&nbsp;Email Id &nbsp; › &nbsp;
              <span>nikeshborkar008@gmail.com</span>
            </a>
          </h3>
          <h3>
            <FaHome className="contactlogotop" />
            &nbsp;&nbsp; Address&nbsp; ›{" "}
            <span>Sakoli, Bhandara (Maharastra)</span>
          </h3>
        </div>
        <div>
          <a
            href="https://www.linkedin.com/in/nikesh-borkar/"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedinIn className="contactlogo" />
          </a>
          <a
            href="https://github.com/NikeshBorkar"
            target="_blank"
            rel="noreferrer"
          >
            <FaGithub className="contactlogo" />
          </a>
          <a href="mailto:nikeshborkar008@gmail.com">
            <FaMailBulk className="contactlogo" />
          </a>
          <a
            href="https://wa.me/+919370176208"
            target="_blank"
            rel="noreferrer"
          >
            <FaWhatsapp className="contactlogo" />
          </a>
        </div>
        <div>
          <p className="thank-you">Thank you for visiting my portfolio!</p>
        </div>
      </div>
    </div>
  );
};
